import { Modal } from 'antd';
import { Dispatch, SetStateAction } from 'react';
import { IAcaoEmLoteDTO } from '../../../models/happy-code-api.model';
import Styles from './components.module.scss';
import BaseDatePicker from './base-date-picker';
import { toMoment } from '../../../util/format';

interface ModalAlteraDataProps {
	open: boolean;
	setOpen: Dispatch<SetStateAction<boolean>>;
	acaoEmLote: IAcaoEmLoteDTO;
	setAcaoEmLote: Dispatch<SetStateAction<IAcaoEmLoteDTO>>;
	handleAction: (value: any) => void;
}

export default function ModalAlteraDataVencimento({ open, setOpen, acaoEmLote, setAcaoEmLote, handleAction }: ModalAlteraDataProps) {
	const handleOk = () => {
		handleAction('ALTERAR_DATA_VENCIMENTO');
		setOpen(false);
	};
	return (
		<Modal
			
			destroyOnClose
			style={{ top: 20 }}
			title="Alterar Valor"
			visible={open}
			onOk={() => handleOk()}
			onCancel={() => setOpen(false)}
			okText="Alterar Valor"
			cancelText="Cancelar"
		>
			<div className={Styles.modalContainer}>
				<BaseDatePicker
					value={toMoment(acaoEmLote?.dataAjuste)}
					onChange={(e) => setAcaoEmLote({ ...acaoEmLote, dataAjuste: e.toDate() })}
					labelConfig={{ label: 'Data de vencimento', tooltip: true, tooltipText: 'Alterar data de vencimento' }}
					width={'60%'}
					placeholder="Alterar data de vencimento"
				/>
			</div>
		</Modal>
	);
}
